import { render } from "./PlaygroundAndSidebar.vue?vue&type=template&id=5a688cdc&scoped=true"
import script from "./PlaygroundAndSidebar.vue?vue&type=script&lang=js"
export * from "./PlaygroundAndSidebar.vue?vue&type=script&lang=js"

import "./PlaygroundAndSidebar.vue?vue&type=style&index=0&id=5a688cdc&lang=scss"
import "./PlaygroundAndSidebar.vue?vue&type=style&index=1&id=5a688cdc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a688cdc"]])

export default __exports__